/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Sinology15Inputs */

const en__field__enum_additionalstudyinterests_study_sinology15 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Sinology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinology`)
};

const de__field__enum_additionalstudyinterests_study_sinology15 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Sinology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinologie`)
};

/**
* | output |
* | --- |
* | "Sinology" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Sinology15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_sinology15 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Sinology15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Sinology15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_sinology15(inputs)
	return de__field__enum_additionalstudyinterests_study_sinology15(inputs)
});
export { _field__enum_additionalstudyinterests_study_sinology15 as "_field__enum_additionalStudyInterests_STUDY_SINOLOGY" }